export interface IGetFhirActivityIconsRequest {
  activityIdentifier: string;
}
